import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import img from "./img/mobileImg.png";

const WhatsAppForm1 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        background: "linear-gradient(135deg, #c5e3f5 0%, #ddeffa 100%)",
      }}
    >
      <Box
        sx={{
          px: {
            xs: 2,
            sm: 4,
            md: 8, // slightly reduced from 10
          },
          py: 8,
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Grid container spacing={4} alignItems="center">
          {/* Left Section with slightly less padding */}
          <Grid item xs={12} md={6} sx={{ px: 2 }}>
            <Typography
              variant={isMobile ? "h4" : "h3"}
              fontWeight="bold"
              gutterBottom
            >
              What are WhatsApp Forms?
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{
                maxWidth: 580,
                fontSize: isMobile ? "1.1rem" : "1.25rem",
                lineHeight: 1.8,
              }}
            >
              Why send WhatsApp users to external forms when you can offer
              seamless, native forms directly within WhatsApp? WhatsApp Forms
              guides users through processes such as booking appointments,
              placing orders, or resolving issues—all without human
              intervention.
            </Typography>

            {/* API Integration Section */}
            <Box sx={{ display: "flex", mt: 4 }}>
              <LinkIcon sx={{ fontSize: 40, mr: 2, color: "#555" }} />
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  API integration
                </Typography>
                <Typography
                  color="text.secondary"
                  sx={{
                    fontSize: isMobile ? "1rem" : "1.15rem",
                    lineHeight: 1.6,
                  }}
                >
                  Receive form information and automatically send it to your
                  preferred CRM or management software. Automate time-consuming
                  tasks effortlessly.
                </Typography>
              </Box>
            </Box>

            {/* Customizable Section */}
            <Box sx={{ display: "flex", mt: 4 }}>
              <Diversity3Icon sx={{ fontSize: 40, mr: 2, color: "#555" }} />
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Customizable
                </Typography>
                <Typography
                  color="text.secondary"
                  sx={{
                    fontSize: isMobile ? "1rem" : "1.15rem",
                    lineHeight: 1.6,
                  }}
                >
                  Design flows tailored to your business needs, from simple FAQs
                  to complex customer journeys.
                </Typography>
              </Box>
            </Box>

            {/* Learn More Button */}
            <Button
              variant="contained"
              sx={{
                mt: 4,
                backgroundColor: "#00D084",
                color: "#fff",
                fontWeight: "bold",
                px: 3,
                py: 1.5,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#00b96e",
                },
              }}
            >
              Learn More →
            </Button>
          </Grid>

          {/* Right Image Section with increased size and equal spacing */}
          <Grid item xs={12} md={6} sx={{ px: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img
                src={img}
                alt="WhatsApp Form Example"
                style={{
                  width: "100%",
                  maxWidth: "1100px", // Increased from 1000px
                  height: "auto",
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default WhatsAppForm1;
